import cx from 'classnames';
import { Info } from 'education-icons';
import { Button, useIntl } from 'platform-components/common';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { customLessonInfoModalActions } from 'common.components/custom-lesson-info-modal/actions';
import { getInfoLandingLink } from 'common.components/custom-lesson/utils';

interface Props {
    shouldShow?: boolean;
    mix?: string;
}

export const CustomLessonInfoButton = React.memo(({ mix, shouldShow = true }: Props) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const link = getInfoLandingLink(intl);

    const handleClick = useCallback(() => {
        dispatch(customLessonInfoModalActions.show());
    }, [dispatch]);

    if (!shouldShow || !link) {
        return null;
    }

    return (
        <Button
            className={cx(mix)}
            icon={<Info />}
            onClick={handleClick}
            size={Button.SIZE.S}
            view={Button.VIEW.CLEAR}
        />
    );
});
